import React from 'react'

import { SimpleProductDetailsFragment } from '../../../graphql/magento'
import { Maybe, Money } from '../../../graphql/search'
import { ProductModalData } from '../../../lib/products/modal/types'
import * as Styled from './styled'

import closeModalIcon from '../../../img/close_modal.svg'

export * as Styled from './styled'

export interface ProductModalContentProps {
  onCloseModal: () => void
  modalData: ProductModalData
  selectedVariant?: SimpleProductDetailsFragment | null
  variantRetailPrice?: Maybe<Money> | undefined
}

export const ProductModalContent: React.FC<ProductModalContentProps> = ({
  children,
  onCloseModal,
  modalData,
  selectedVariant,
  variantRetailPrice,
}) => {
  const { item, productDetails } = modalData
  return (
    <Styled.Container container spacing={2}>
      <Styled.CloseButton onClick={onCloseModal} aria-label="Close modal">
        <img alt="Close modal" src={closeModalIcon} />
      </Styled.CloseButton>
      <Styled.HeaderContainer>
        <Styled.Heading
          item={item}
          selectedVariant={selectedVariant}
          variantRetailPrice={variantRetailPrice}
          tagline={productDetails?.tagline}
        />
      </Styled.HeaderContainer>
      <Styled.BodyContainer>
        <Styled.BodyHalfContainer>
          {selectedVariant && item ? (
            <Styled.ItemImages item={item} selectedVariant={selectedVariant} />
          ) : null}
          {productDetails?.shortDescription && (
            <Styled.ItemShortDescription>
              {productDetails.shortDescription}
            </Styled.ItemShortDescription>
          )}
        </Styled.BodyHalfContainer>
        <Styled.BodyHalfContainer>{children}</Styled.BodyHalfContainer>
      </Styled.BodyContainer>
    </Styled.Container>
  )
}
